import { GridColDef } from '@mui/x-data-grid-pro'

export const testing = true
const MODAL_HEADER_HEIGHT = 45
const MODAL_BODY_HEIGHT = 455
const MODAL_FOOTER_HEIGHT = 60
const MODAL_HEIGHT =
  MODAL_HEADER_HEIGHT + MODAL_BODY_HEIGHT + MODAL_FOOTER_HEIGHT
const MODAL_WIDTH = 790

export const modalSizes = {
  headerHeight: MODAL_HEADER_HEIGHT,
  bodyHeight: MODAL_BODY_HEIGHT,
  footerHeight: MODAL_FOOTER_HEIGHT,
  height: MODAL_HEIGHT,
  width: MODAL_WIDTH
}
export const TOP_BARS_HEIGHT = 55

export const RATE_DAY_VALUE_CONFIRM_LIMIT = 10000

export const DATA_GRID_DEFAULT_LIST_COLUMN_PROPS: Partial<GridColDef> = {
  resizable: false,
  disableColumnMenu: true,
  sortable: false,
  headerAlign: 'center',
  align: 'center',
  flex: 1
}

export const DEFAULT_LOAD_DAYS_QTY = 14

// _____________________________

export const RATES_TABLE_BORDER_COLOR = '#c4c4c4'

export const SATURDAY_AND_SUNDAY_BACKGROUND_COLOR = '#C2E0FF'

export const AVAILABILITY_COLORS = {
  AVAILABLE_BLOCKED: { bg: '#686868', font: 'white' },
  UNAVAILABLE_BLOCKED: { bg: '#ee5858', font: 'white' },
  AVAILABLE_OWNER_CHANNEL: { bg: '#eae23f', font: 'black' },
  UNAVAILABLE_OWNER_CHANNEL: { bg: '#9610ad', font: 'white' }
}
